import React from 'react';
import ColorPicker from '../ui/ColorPicker';

const HeaderBlockEditor = ({ block, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(block.id, {
      config: {
        ...block.config,
        [field]: value,
      },
    });
  };

  const handleStyleChange = (field, value) => {
    onUpdate(block.id, {
      styles: {
        ...block.styles,
        [field]: value,
      },
    });
  };

  const handleAddLink = () => {
    const newLink = {
      label: 'Link',
      url: '#',
    };
    handleChange('navigationLinks', [...(block.config.navigationLinks || []), newLink]);
  };

  const handleUpdateLink = (index, field, value) => {
    const updatedLinks = [...(block.config.navigationLinks || [])];
    updatedLinks[index] = { ...updatedLinks[index], [field]: value };
    handleChange('navigationLinks', updatedLinks);
  };

  const handleRemoveLink = (index) => {
    const updatedLinks = (block.config.navigationLinks || []).filter((_, i) => i !== index);
    handleChange('navigationLinks', updatedLinks);
  };

  const handleLogoChange = (field, value) => {
    handleChange('logo', {
      ...(block.config.logo || {}),
      [field]: value,
    });
  };

  return (
    <div>
      <div className="editor-section">
        <h4 className="editor-section-title">Header Content</h4>

        <div className="editor-field">
          <label>Logo URL</label>
          <input
            type="url"
            value={block.config.logo?.url || ''}
            onChange={(e) => handleLogoChange('url', e.target.value)}
            placeholder="https://example.com/logo.png"
          />
        </div>

        <div className="editor-field">
          <label>Logo Width (px)</label>
          <input
            type="number"
            value={block.config.logo?.width || 120}
            onChange={(e) => handleLogoChange('width', parseInt(e.target.value))}
            min="50"
            max="300"
            placeholder="120"
          />
        </div>

        <div className="editor-field">
          <label>Logo Height (px)</label>
          <input
            type="number"
            value={block.config.logo?.height || 40}
            onChange={(e) => handleLogoChange('height', parseInt(e.target.value))}
            min="20"
            max="120"
            placeholder="40"
          />
        </div>

        <div className="editor-field">
          <label>Navigation Links</label>
          {(block.config.navigationLinks || []).map((link, index) => (
            <div key={index} style={{ marginBottom: '1rem', padding: '1rem', border: '1px solid #333', borderRadius: '0.375rem' }}>
              <div className="editor-field">
                <label>Link Text</label>
                <input
                  type="text"
                  value={link.label || ''}
                  onChange={(e) => handleUpdateLink(index, 'label', e.target.value)}
                  placeholder="Home"
                />
              </div>
              <div className="editor-field">
                <label>Link URL</label>
                <input
                  type="url"
                  value={link.url || ''}
                  onChange={(e) => handleUpdateLink(index, 'url', e.target.value)}
                  placeholder="https://..."
                />
              </div>
              <button
                type="button"
                onClick={() => handleRemoveLink(index)}
                style={{ color: '#ff4444', fontSize: '0.875rem', marginTop: '0.5rem' }}
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            className="btn-secondary"
            onClick={handleAddLink}
            style={{ width: '100%', marginTop: '0.5rem' }}
          >
            Add Navigation Link
          </button>
        </div>
      </div>

      <div className="editor-section">
        <h4 className="editor-section-title">Styling</h4>

        <div className="editor-field">
          <ColorPicker
            label="Background Color"
            color={block.styles.backgroundColor || '#1a1a1a'}
            onChange={(value) => handleStyleChange('backgroundColor', value)}
          />
        </div>

        <div className="editor-field">
          <label>Text Alignment</label>
          <select
            value={block.styles.textAlign || 'center'}
            onChange={(e) => handleStyleChange('textAlign', e.target.value)}
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>

        <div className="editor-field">
          <label>Padding (px)</label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
            <input
              type="number"
              value={block.styles.padding?.top || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, top: parseInt(e.target.value) })}
              placeholder="Top"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.right || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, right: parseInt(e.target.value) })}
              placeholder="Right"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.bottom || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, bottom: parseInt(e.target.value) })}
              placeholder="Bottom"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.left || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, left: parseInt(e.target.value) })}
              placeholder="Left"
              min="0"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderBlockEditor;
